import { ref } from "vue";
import { getAllUnits , deleteUnit , UpdateUnit , addUnit , search , filter, userUnits} from "@/api/units";


const state = {
    units: ref({}),
    isLoading: ref(false),
    lists: ref([]),

};
const actions = {
    async fetchUnits({commit} , page){
        try{
            const response = await getAllUnits(page);
            commit('SET_UNITS' , response.data.units);
            commit('SET_LISTS' , response.data.lists);
        }catch(error){
            console.log(error)
        }
    },
    async searchUnit({commit} , data){
        try{
            const response = await search( data.value , data.page);
            commit('SET_UNITS' , response.data.units);
        }catch(error){
            console.log(error)
        }
    },
    async addNewUnit({commit} , unit){
        try{
            const resUnit = await addUnit(unit);
            commit('ADD_UNIT' , resUnit.data.unit);
        }catch(error){
            console.log(error)
        }
    },
    async deleteUnit({commit} , id){
        try{
            await deleteUnit(id);
            commit('DELETE_UNIT' , id);

        }catch(e){
            console.log(e);
        }
    },
    async updateUnit({commit} , unit){
        try{
            const response = await UpdateUnit(unit);
            commit('UPDATE_UNIT' , response.data.unit);
        }catch(e){
            throw new Error(e);
        }
    },
    async filter({commit} , {form , page}){
        try{
            const response = await filter(form , page);
            commit('SET_UNITS' , response);
        }catch(e){
            throw new Error(e);
        }
    },
    async getUserUnits({commit} , id){
        try{
            const response = await userUnits(id);
            commit('SET_UNITS' , response.data.units);
        }catch(e){
            throw new Error(e);
        }
    },
};
const mutations = {
    UPDATE_UNIT(state , updatedunit){
        state.units.data.map((unit,index) => unit.id == updatedunit.id ? state.units.data[index] = updatedunit : null);
    },
    DELETE_UNIT(state , id){
        state.units.data = state.units.data.filter(unit => unit.id !== id);
    },
    SET_LISTS(state, lists){
        state.lists = lists;
    },
    SET_UNITS(state , units){
        state.units = units;
        state.units.data = state.units.data.map(unit => ({
            ...unit,
            is_unit_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        }))
    },
    ADD_UNIT(state , unit){
        console.log(unit);
        state.units.data.unshift({
            ...unit,
            is_unit_show:false,
            is_edit_active:false,
        });
    }
};
const getters = {
    getUnits: (state) => state.units,
    getLists:(state) => state.lists,
};


export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};